export default function useLeadsSDK() {
  return window?._elnkLeadsSDK || {};
}
